import { FC } from 'react'
import { Button } from 'antd'
import type { ButtonProps } from 'antd'
import { useCpdLogin } from 'features/learn-worlds'

type CpdLoginButtonProps = ButtonProps & {
  children?: React.ReactNode
}

const CpdLoginButton: FC<CpdLoginButtonProps> = ({ children = 'CPD Module', loading, onClick, ...buttonProps }) => {
  const { login, isFetching } = useCpdLogin()

  const handleClick: ButtonProps['onClick'] = async (event) => {
    onClick?.(event)
    await login()
  }

  return (
    <Button {...buttonProps} loading={loading ?? isFetching} onClick={handleClick}>
      {children}
    </Button>
  )
}

export default CpdLoginButton
